<template>
    <md-card style="margin-top: 40px;">
        <md-card-header class="md-card-header-icon md-card-header-blue">
            <div class="card-icon">
                <font-awesome-icon class="md-icon" :icon="['fa', 'sticky-note']"/>
            </div>
            <h4 class="title">Notes</h4>
        </md-card-header>
        <md-card-content>
            <div>
                <div class="md-size-100">
                    <form @submit.prevent="updateClientNote">
                        <div class="md-layout">
                            <div class="md-layout-item">
                                <md-field class="md-invalid md-size-90">
                                    <label>Note client</label>
                                    <md-textarea v-model="client.notes" md-autogrow></md-textarea>
                                    <validation-error :errors="apiValidationErrors.notes" />
                                </md-field>
                            </div>
                            <md-button type="submit" class="md-button md-icon-button md-success md-theme-default my-auto ml-2">
                                <font-awesome-icon class="md-icon" :icon="['fa', 'save']"/>
                            </md-button>
                        </div>
                    </form>
                </div>
                <div class="md-size-100 mt-4">
                    <form @submit.prevent="updateSiteNotes">
                        <div class="md-layout">
                            <div class="md-layout-item">
                                <md-field class="md-invalid md-size-90">
                                    <label>Note site</label>
                                    <md-textarea v-model="site.note" md-autogrow></md-textarea>
                                    <validation-error :errors="apiValidationErrors.note" />
                                </md-field>
                            </div>
                            <md-button type="submit" class="md-button md-icon-button md-success md-theme-default my-auto ml-2">
                                <font-awesome-icon class="md-icon" :icon="['fa', 'save']"/>
                            </md-button>
                        </div>
                    </form>
                </div>
                <div class="md-size-100 mt-4" v-if="user.type_id !== 3">
                    <form @submit.prevent="updateSitePlanningNotes">
                        <div class="md-layout">
                            <div class="md-layout-item">
                                <md-field class="md-invalid md-size-90">
                                    <label>Infos planification</label>
                                    <md-textarea v-model="site.planning_information"
                                                 md-autogrow></md-textarea>
                                    <validation-error :errors="apiValidationErrors.planning_information"/>
                                </md-field>
                            </div>
                            <md-button type="submit"
                                       class="md-button md-icon-button md-success md-theme-default my-auto ml-2">
                                <font-awesome-icon class="md-icon" :icon="['fa', 'save']"/>
                            </md-button>
                        </div>
                    </form>
                </div>
            </div>
        </md-card-content>
    </md-card>
</template>

<script>
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";
import {mapState} from "vuex";

export default {
    name: "Notes",
    components: { ValidationError },
    mixins: [formMixin],
    props: {
        site: {
            type: Object,
            required: true
        },
        client: {
            type: Object,
            required: true
        },
    },
    computed: mapState({
        user: state => state.profile.me,
    }),
    methods: {
        async updateClientNote() {
            try {
                this.resetApiValidation()
                await this.$store.dispatch("clients/updateClientNotes", {
                    id: this.client.id,
                    notes: this.client.notes
                })
                await this.$store.dispatch("alerts/success", "Note du client modifiée");
            } catch (e) {
                this.setApiValidation(e.response.data.errors)
            }
        },
        async updateSiteNotes() {
            try {
                this.resetApiValidation()
                await this.$store.dispatch('sites/updateNote', {
                    id: this.site.id,
                    note: this.site.note
                })
                await this.$store.dispatch('alerts/success', 'Note du site modifiée')
            } catch (e) {
                this.setApiValidation(e.response.data.errors)
            }
        },
        async updateSitePlanningNotes() {
            try {
                this.resetApiValidation()
                await this.$store.dispatch('sites/updateNote', {
                    id: this.site.id,
                    planning_information: this.site.planning_information
                })
                await this.$store.dispatch('alerts/success', 'Infos planification du site modifiée')
            } catch (e) {
                this.setApiValidation(e.response.data.errors)
            }
        }
    }
}
</script>

<style scoped>

</style>
